module.exports = __webpack_public_path__ + "assets/img/tools_bg.52ce9262.png";